import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { FaChevronDown } from "react-icons/fa";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [isResumeDropdownOpen, setIsResumeDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleResumeDropdown = () => {
    setIsResumeDropdownOpen(!isResumeDropdownOpen);
  };

  const closeResumeDropdown = () => {
    setIsResumeDropdownOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setActiveSection(sectionId);
      closeMenu();
    }
  };

  // Function to view resume
  const viewResume = () => {
    window.open('/Kollati_bhanu_Prakash.pdf', '_blank');
    setIsResumeDropdownOpen(false);
  };

  // Function to download resume
  const downloadResume = () => {
    const link = document.createElement('a');
    link.href = '/Kollati_bhanu_Prakash.pdf';
    link.download = 'Kollati_bhanu_Prakash_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsResumeDropdownOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "about", "projects", "skills", "education", "certifications", "contact"];
      const scrollPosition = window.scrollY + 100;

      for (const sectionId of sections) {
        const section = document.getElementById(sectionId);
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionBottom = sectionTop + section.offsetHeight;
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isResumeDropdownOpen && !event.target.closest('.resume-dropdown')) {
        setIsResumeDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isResumeDropdownOpen]);

  const navLinks = [
    { id: "home", label: "HOME" },
    { id: "about", label: "ABOUT" },
    { id: "projects", label: "PROJECTS" },
    { id: "skills", label: "SKILLS" },
    { id: "education", label: "EDUCATION" },
    { id: "certifications", label: "CERTIFICATIONS" },
    { id: "contact", label: "CONTACT" },
  ];

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo" onClick={() => scrollToSection("home")}>
          BP
        </div>
        <ul className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
          {navLinks.map((link) => (
            <li className="nav-item" key={link.id}>
              <button
                className={`nav-link ${activeSection === link.id ? "active" : ""}`}
                onClick={() => scrollToSection(link.id)}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* Resume Dropdown */}
        <div className="resume-dropdown">
          <button 
            className="resume-btn" 
            onClick={toggleResumeDropdown}
          >
            RESUME <FaChevronDown className={`dropdown-arrow ${isResumeDropdownOpen ? 'open' : ''}`} />
          </button>
          {isResumeDropdownOpen && (
            <div className="dropdown-menu">
              <button className="dropdown-item" onClick={viewResume}>
                <span className="dropdown-icon">👁️</span> VIEW
              </button>
              <button className="dropdown-item" onClick={downloadResume}>
                <span className="dropdown-icon">⬇️</span> DOWNLOAD
              </button>
            </div>
          )}
        </div>

        <div className={`hamburger ${isMenuOpen ? "active" : ""}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;